import { WifiXIcon } from "@phosphor-icons/react";
import { useIntl } from "react-intl";

import PageError from "./PageError";

export const NoNetworkConnectionPageError = () => {
  const intl = useIntl();

  return (
    <PageError
      title={intl.formatMessage({ id: "noNetworkConnetionErrorTitle" })}
      subtitles={[
        intl.formatMessage({ id: "noNetworkConnetionErrorSubtitle" }),
      ]}
      back={{
        text: intl.formatMessage({ id: "backToHome" }),
        options: { to: "/" },
      }}
      icon={<WifiXIcon size={60} color="#295942" />}
      hideWhatsAppButton
    />
  );
};
